import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=90bb53f4&scoped=true&"
import script from "./Plain.vue?vue&type=script&lang=js&"
export * from "./Plain.vue?vue&type=script&lang=js&"
import style0 from "./Plain.vue?vue&type=style&index=0&id=90bb53f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bb53f4",
  null
  
)

component.options.__file = "Plain.vue"
export default component.exports